export function pushWebEngageEvents(data: { eventName: string, details: any }) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: data.eventName,
        ...data.details
      })
    } catch (err) {
      console.log(err)
    }
  }